<template>
  <v-dialog :value="value" :max-width="maxWidth" persistent scrollable>
    <v-card>
      <v-card-title style="flex-wrap: nowrap">
        <h2 class="headline" :class="titleClass">
          <slot name="title"></slot>
        </h2>
        <v-spacer></v-spacer>
        <v-btn flat icon>
          <v-icon class="error--text" @click="$emit('close')">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 80vh" ref="body">
        <slot name="content"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ob-dialog',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    maxWidth: {
      type: Number,
      default: 500,
      required: false
    },
    titleClass: {
      type: String,
      default: 'primary--text',
      required: false
    }
  },
  watch: {
    value (v) {
      if (!v) {
        // setTimeout(() => {
        this.$refs.body.scrollTo({ top: 0, behavior: 'smooth' })
        // }, 500)
      }
    }
  }
}
</script>

<style>

</style>
